module.exports = __webpack_public_path__ + "media/images/linkedin-05e9207e29f1bd2cf36bb3d60e284d4c.png";